export enum PromoEvent {
  REDEEMED = 'TL_PROMO_REDEEMED_EVENT',
  REFERRAL_REDEEMED = 'TL_REFERRAL_REDEEMED_EVENT',
}

export enum PromoErrorMessage {
  QUANTITY_LT_NEG_ONE = 'quantity cannot be less than -1',
  QUANTITY_INTEGER = 'quantity must be an integer',
  QAUNTITY_LT_USE_COUNT = 'quantity cannot be less than the useCount',
  QUANTITY_ZERO = 'quantity cannot be 0',
  PROMO_ID_REQUIRED = 'promoId is required',
  PROMO_CODE_REQUIRED = 'promoCode is required',
  PROMO_CODE_STRING = 'code must be a string',
  EVENT_ID_REQUIRED = 'eventId is required',
  INVENTORY_ID_REQUIRED = 'inventoryId is required',
  PROMO_CREDIT_ASSOCIATE_EVENTS = 'Promo for credit cannot be associated to events',
  PROMO_CREDIT_ASSOCIATE_INVENTORY = 'Promo for credit cannot be associated to inventory',
  PROMO_CREDIT_ASSOCIATED_EVENTS = 'Promo for credit is not associated with events',
  PROMO_CREDIT_ASSOCIATED_INVENTORY = 'Promo for credit is not associated with inventory',
  PROMO_ID_NOT_FOUND_FORMAT = 'promo %s not found',
  PROMO_CODE_NOT_FOUND_FORMAT = 'promo with code %s not found',
  PROMO_CODE_NOT_UNIQUE = 'A promo already exists with this code',
  PROMO_CODE_ALPHANUMERIC = 'A promo code can only contain letters, numbers, underscores or dashes',
  PROMO_CODE_INVALID = 'Sorry that promo code is not valid',
  PROMO_CODE_ALREADY_USED = 'You have already used this promo code',
  PROMO_CODE_ONLY_NEW = 'The promo code is only valid for new customers',
  PROMO_CODE_EXPIRED = 'The promo code has expired and is no longer valid',
  PROMO_CODE_ONLY_ONE_REFERRAL = 'You can only use one referral code',
  PROMO_CODE_CANNOT_USE_OWN_REFERRAL = "Hey we saw that... you can't use your own referral code",
  PROMO_CODE_UNAVAILABLE = 'The promo code is no longer available',
  PROMO_CODE_ALREADY_USED_CAMPAIGN = 'Sorry you can only redeem this promotion once',
  PROMO_CODE_ONLY_NO_CREDIT = 'Sorry this promo is only valid for customer with no credit',
  PROMO_CODE_ONLY_NO_BOOKING = 'Sorry this promo is only valid for customers who have not booked with us before',
  PROMO_CODE_ONLY_NEW_MEMBERS = 'The promo code is only valid for new members',
}
